// -----------------------------------------------------------------------------------------------------------------
// Resource Name
// -----------------------------------------------------------------------------------------------------------------

export const MAP_RESOURCE_PROP_RESOURCE_NAME = 'resourceName';


// -----------------------------------------------------------------------------------------------------------------
// Resource Id/Slug
// -----------------------------------------------------------------------------------------------------------------

export const MAP_RESOURCE_PROP_RESOURCE_ID   = 'resourceId';
export const MAP_RESOURCE_PROP_RESOURCE_SLUG = 'resourceSlug';


// -----------------------------------------------------------------------------------------------------------------
// Collection expected props
// -----------------------------------------------------------------------------------------------------------------

export const MAP_RESOURCE_COLLECTION_PROP_PAGE    = 'page';
export const MAP_RESOURCE_COLLECTION_PROP_FILTERS = 'filters';


// -----------------------------------------------------------------------------------------------------------------
// Api URL props
// -----------------------------------------------------------------------------------------------------------------

export const MAP_RESOURCE_PROP_API_URL = 'apiUrl';


// -----------------------------------------------------------------------------------------------------------------
// Api Fetch props
// -----------------------------------------------------------------------------------------------------------------

export const MAP_RESOURCE_PROP_API_IS_FETCHING = 'apiIsFetching';
export const MAP_RESOURCE_PROP_API_FETCH_ERROR = 'apiFetchError';
export const MAP_RESOURCE_PROP_API_FETCH       = 'apiFetch';


// -----------------------------------------------------------------------------------------------------------------
// Api update props
// -----------------------------------------------------------------------------------------------------------------

export const MAP_RESOURCE_PROP_API_IS_CREATING      = 'mapResourceApiIsCreating';
export const MAP_RESOURCE_PROP_API_CREATE_ERROR     = 'mapResourceApiCreateError';
export const MAP_RESOURCE_PROP_API_CREATE           = 'mapResourceApiCreate';
export const MAP_RESOURCE_PROP_API_CREATED_RESOURCE = 'mapResourceApiCreatedResource';


// -----------------------------------------------------------------------------------------------------------------
// Api update props
// -----------------------------------------------------------------------------------------------------------------

export const MAP_RESOURCE_PROP_API_IS_UPDATING  = 'mapResourceApiIsUpdating';
export const MAP_RESOURCE_PROP_API_UPDATE_ERROR = 'mapResourceApiUpdateError';
export const MAP_RESOURCE_PROP_API_UPDATE       = 'mapResourceApiUpdate';


// -----------------------------------------------------------------------------------------------------------------
// Autoloader
// -----------------------------------------------------------------------------------------------------------------

export const MAP_RESOURCE_PROP_DISABLE_AUTOLOAD = 'disableAutoload';


// -----------------------------------------------------------------------------------------------------------------
// Data constants
// -----------------------------------------------------------------------------------------------------------------

export const MAP_RESOURCE_DATA_PROP_RESOURCE_DATA       = 'resourceData';
export const MAP_RESOURCE_DATA_PROP_RESOURCE_ITEM       = 'resourceItem';
export const MAP_RESOURCE_DATA_PROP_RESOURCE_COLLECTION = 'resourceCollection';


// -----------------------------------------------------------------------------------------------------------------
// Exists
// -----------------------------------------------------------------------------------------------------------------

export const MAP_RESOURCE_EXISTS_IS_CHECKING = 'mapResourceExistsIsChecking';
export const MAP_RESOURCE_EXISTS_EXISTS      = 'mapResourceExistsExists';
export const MAP_RESOURCE_EXISTS_RESOURCE    = 'mapResourceExistsResource';



// WEBPACK FOOTER //
// ./src/components/resources/mapResourceProps.const.js